import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { LayoutDashboard, FileText, Users, UserCircle, ChevronLeft, ChevronRight, FileBarChart, Calendar, Clock } from 'lucide-react';
import { SECTION_TO_PATH, HIDDEN_CONSULTANT_MODULES } from '../config/roles';
import './SidebarNavigation.css';

const ALL_NAV_ITEMS = [
  { id: 'dashboard', label: 'Quiz Dashboard', icon: LayoutDashboard },
  { id: 'quiz', label: 'Quiz', icon: FileText },
  { id: 'reports', label: 'Quiz Reports', icon: FileBarChart },
  { id: 'calendar', label: 'Calendar', icon: Calendar },
  { id: 'timesheets', label: 'Timesheets', icon: Clock },
  { id: 'users', label: 'User Management', icon: Users },
  { id: 'profile', label: 'Profile', icon: UserCircle },
];

const SidebarNavigation = ({ activeSection, isMobileOpen, onMobileClose, isCollapsed, onToggleCollapse, allowedModules = [], role = null }) => {
  const location = useLocation();
  // Keep ?previewRole=&demo= when switching sections
  const withSearch = (path) => ({ pathname: path, search: location.search });

  const hiddenIds = role === 'consultant' ? HIDDEN_CONSULTANT_MODULES : [];
  const sourceItems = allowedModules.length > 0
    ? ALL_NAV_ITEMS.filter((item) => allowedModules.includes(item.id))
    : ALL_NAV_ITEMS.filter((item) => !hiddenIds.includes(item.id));
  const navigationItems = sourceItems.filter((item) => !hiddenIds.includes(item.id));
  const homePath = SECTION_TO_PATH[navigationItems[0]?.id] || SECTION_TO_PATH.quiz;

  return (
    <aside className={`sidebar-nav ${isCollapsed ? 'collapsed' : ''} ${isMobileOpen ? 'mobile-open' : ''}`}>
      <div className="sidebar-header">
        <NavLink
          to={withSearch(homePath)}
          className="sidebar-logo"
          onClick={() => isMobileOpen && onMobileClose()}
          title="Go to home"
          aria-label="Go to home"
        >
          <img
            src="/diologic-logo.png"
            alt="DIOLOGIC"
            className={`sidebar-logo-full ${isCollapsed ? 'is-collapsed' : ''}`}
          />
        </NavLink>
      </div>

      <nav className="sidebar-menu">
        {navigationItems.map((item) => {
          const IconComponent = item.icon;
          const path = SECTION_TO_PATH[item.id];
          if (!path) return null;
          return (
            <NavLink
              key={item.id}
              to={withSearch(path)}
              className={({ isActive }) => `sidebar-item ${isActive ? 'active' : ''}`}
              onClick={() => isMobileOpen && onMobileClose()}
              title={isCollapsed ? item.label : ''}
              end={item.id === 'dashboard'}
            >
              <IconComponent className="sidebar-icon" size={20} />
              {!isCollapsed && <span className="sidebar-label">{item.label}</span>}
              {activeSection === item.id && !isCollapsed && (
                <span className="sidebar-indicator"></span>
              )}
            </NavLink>
          );
        })}
      </nav>

      <div className="sidebar-footer">
        <button 
          className="sidebar-toggle"
          onClick={() => onToggleCollapse(!isCollapsed)}
          aria-label="Toggle sidebar"
          title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          {isCollapsed ? <ChevronRight size={18} /> : <ChevronLeft size={18} />}
        </button>
      </div>
    </aside>
  );
};

export default SidebarNavigation;
